import { useState } from "react";
import emailjs from "@emailjs/browser";

const useForm = (formValidation) => {
  const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState({
    firstName: "",
    email: "",
    message: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = formValidation(formValues);
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      setIsSubmitted((prev) => !prev);
    }
    emailjs
      .sendForm(
        "service_jydegmx",
        "template_roq8deg",
        e.target,
        "RK0TsRpfNOyFsAHeJ"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return { handleChange, formValues, errors, handleSubmit, isSubmitted };
};
export default useForm;
